import React from "react";
import { FaShippingFast, FaBoxOpen, FaGlobe, FaFileAlt } from "react-icons/fa"; // Import Icons
import "./ExportDetails.css";

const ExportDetails = () => {
  return (
    <section className="export-details-section">
      <h2 className="export-title">🌎 Our Export Services</h2>
      <p className="export-description">
        At Kozee, we specialize in seamless global exports, ensuring top-notch 
        logistics, compliance, and efficient delivery to businesses worldwide.
      </p>

      <div className="export-services">
        <div className="export-card">
          <FaBoxOpen className="export-icon" />
          <h3>Product Sourcing & Packaging</h3>
          <p>We ensure high-quality sourcing, custom packaging, and secure handling.</p>
        </div>

        <div className="export-card">
          <FaShippingFast className="export-icon" />
          <h3>International Shipping</h3>
          <p>Fast and reliable air, sea, and land transport for global delivery.</p>
        </div>

        <div className="export-card">
          <FaFileAlt className="export-icon" />
          <h3>Customs Clearance & Documentation</h3>
          <p>We handle customs, duties, and documentation to ensure smooth clearance.</p>
        </div>

        <div className="export-card">
          <FaGlobe className="export-icon" />
          <h3>Global Market Distribution</h3>
          <p>Connecting businesses with trusted distributors worldwide.</p>
        </div>
      </div>
    </section>
  );
};

export default ExportDetails;
